import { ReadOnlyEndpointsApi } from '../openapi';
import { config } from './config';

export const ReadOnlyClient = new ReadOnlyEndpointsApi(config);
